import { render, staticRenderFns } from "./workBench.vue?vue&type=template&id=db6a2aba&scoped=true&"
import script from "./workBench.vue?vue&type=script&lang=js&"
export * from "./workBench.vue?vue&type=script&lang=js&"
import style0 from "./workBench.vue?vue&type=style&index=0&id=db6a2aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6a2aba",
  null
  
)

export default component.exports